<template>
  <div class="nav-130 d-print-none">
    <div class="right-menu-icons ">

      <div class="d-lg-none">
        <slot>
          <i class="bi h4 bi-list-nested" @click="menu200Status=!menu200Status"></i>

        </slot>
      </div>
    </div>
    <div class="right-menu">
      <div class="d-none d-lg-block right-menu-items ">

        <m-menu-300 :menuPosition="rightMenu"/>


      </div>
    </div>

    <div class="logo">
      <m-a :href="{name:'Home'}">
        <img :src="findAttributeOnSiteInfo('icon')[0]" :alt="findAttributeOnSiteInfo('site_name')[0]">
      </m-a>
    </div>


    <div class="left-menu">
      <div class="d-none d-lg-block left-menu-items">
        <m-menu-300 :menuPosition="leftMenu"/>
      </div>
    </div>

    <div class="left-menu-icons">
      <m-a :href="shoppingCartLink"><i class="mx-1 h5 bi bi-bag-dash icon-left-item"></i></m-a>
      <m-a :href="`${findAttributeOnSiteInfo('dashboard_link')[0]}/dashboard`"><i
          class="mx-1 h5 bi bi-person icon-left-item"></i></m-a>
      <m-a v-if="isAuthenticated" :href="{name:'WishListUser',params:{user:getUserId}}"><i
          class="mx-1 h5 bi bi-heart icon-left-item"></i></m-a>
      <m-search-input2 class="nav-130-search"/>
    </div>
  </div>

  <div v-if="menu200Status" class="menu-200-dropdown-disable w-100 nav-200-sub-menu  m-1 mx-auto">
    <div class="">
      <menu200 class="nav-200-main-sub-menu p-1 " :menu-position="mobileMenu"/>
    </div>
  </div>


</template>

<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import mA from '../../Tags/A.vue'
import {mapGetters} from "vuex";
import mSearchInput2 from "../../Search/Input/SearchInput2.vue";
import Menu200 from "../../Menu/Menu200/Menu200.vue";
import mMenu300 from "../../Menu/Menu300/Menu300.vue";
import {NavComputed} from "../../Navs/NavComputed";

export default {
  name: "Nav130",
  components: {mSearchInput2, mA, Menu200, mMenu300},
  props: {
    leftMenu: {
      default: 'blog_nav'
    },
    rightMenu: {
      default: 'blog_nav'
    },
    mobileMenu: {
      default: 'blog_nav'
    }
  },
  data() {
    return {
      megaMenuVisible: false,
      menu200Status: false,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      getUserId: "User/getUserId"
    }),
    ...NavComputed,
  },
  methods: {
    findAttributeOnSiteInfo,
  }
}

</script>

<style scoped>
.nav-130 {
  display: flex;
  height: 80px;
  position: relative;
  background: #fff;
  z-index: 999;
  align-items: center;
}

.left-menu {
  width: calc(35% - 100px);
  display: flex;
}


.right-menu {
  width: calc(35% - 100px);
  display: flex;
  justify-content: flex-end;
}

.right-menu-icons {
  width: calc(20% - 100px);
  display: flex;
}


.left-menu-icons {
  width: calc(20% - 100px);
  display: flex;
  justify-content: end;
}

.logo {
  display: flex;
  width: 200px;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.logo img {
  width: 150px;
}


@media screen and (max-width: 1000px) {
  .right-menu-icons {
    width: calc(50% - 100px);
  }


  .left-menu-icons {
    width: calc(50% - 100px);
  }
}

.nav-130-search :deep(button) {
  margin: 0 !important;
  padding: 0 !important;
}

</style>